import * as React from 'react';
import {Grid} from "@mui/material";
import DriveRowActionCell from "../DriveRow/DriveRowActionCell";
import useDrive from "../../hooks/useDrive";
import DriveService from "../../services/DriveService";
import styles from "./fileAndFolderTbl.module.css";
import {FileThumbnail} from "../FileThumbnail";
import {DRIVE_TYPES} from "../../config/appConst";
import { useState } from "react";

export const FolderContentGrid = ({rows}) => {
    const {CurrentDrive, changeCurrentDrive, changeSelectedRow, changePreviewObject} = useDrive();
    

    const loadMe = async row => {
        const {parent, driveType} = CurrentDrive;
        // console.log("driveType", driveType)
        const path = parent ? parent + '/' + row.Key : row.Key;
        if (row.type === 'folder') {
            const res = await DriveService.getFileTree(path, driveType);
            let current = {parent: path, driveType: driveType};
            if (driveType === DRIVE_TYPES.SHARED) {
                current.sharedDrive = res;
            } else {
                current.drive = res;
            }
            changeCurrentDrive(current);

        }
       
    }

    const showMe = row => {
        // console.log('show me');
        
        changeSelectedRow(row)
        changePreviewObject(row)
    }

    const clickHandler = row => {
        if (row.type === 'folder') {
            loadMe(row)
        } else {
            showMe(row)
        }
    }
    return (
        <Grid container
              direction="row"
              // justifyContent="center"
              alignItems="center"
              spacing={2}
              rowSpacing={3}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        >
            {
                rows.map(row => {
                    return <Grid item xl={2} xs={4} md={2} key={row.id}>
                            <div className={styles.gridContent}>
                                <div className={styles.gridItemAction}>
                                    <DriveRowActionCell show={true} row={row} cell={false} grid={true} loadMe={() => loadMe(row)}/>
                                </div>
                                <span onClick={() => clickHandler(row)}>
                                    <FileThumbnail row={row} width="100%"/>
                                </span>
                                <div className={styles.gridItemName}>{row.Key}</div>
                            </div>
                    </Grid>
                })
            }
        </Grid>
    );
};